module.exports = __webpack_public_path__ + "img/u36.2080fa58.svg";